import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AuthServicesService } from 'src/app/auth/services/auth-services.service';
import {
  clearReducer,
} from 'src/app/auth/state/auth.actions';
import { CreateOrderService } from 'src/app/click-it/create-order/cement/Services/create-order.service';
import { GoogleEventsService } from '../analyticservice/google-events.service';
import { MigrationPopupService } from 'src/app/click-it/services/migration-popup.service';

@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: [
    './common-modal.component.scss',
    './common-modal.component.rtl.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CommonModalComponent implements OnInit {
  @Input() contentToPrint: any;
  @Input() successData: any;
  @Input() successDataMsg: any;
  @Output() cancelModal = new EventEmitter();
  @Output() confirmToSwitchAccount = new EventEmitter();
  @Output() confirmToDeactivate = new EventEmitter();
  @Output() confirmationData = new EventEmitter();
  @Output() confirmToExitForm = new EventEmitter();
  @Output() openPrivacyPolicyToAgree = new EventEmitter();
  @Input() errorData: any;
  @Input() errorsData: any;

  firstModal = true;
  LogoutButtonValue: any;
  modalFunctionIcon: any;
  showWarningIcon: boolean = false;
  OtpData: any;
  cartData:any;
  constructor(
    private authService: AuthServicesService,
    private router: Router,
    private store: Store<any>,
    public translate: TranslateService,
    private analyticService: GoogleEventsService,
    private createOrderService: CreateOrderService,
     private migrattionPopUp: MigrationPopupService
  ) {}

  ngOnInit(): void {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.OtpData = data?.authReducer?.otpVerifiedDetails;
        this.cartData = data?.cartReducer?.cartData;
      });
      let value=this.contentToPrint?.value;
    if (this.contentToPrint?.value === 'logout') {
      this.modalFunctionIcon = 'assets/icons/logout-confirm.svg';
      this.LogoutButtonValue = 'Logout';
    } else if ((value === 'switchAccount')||(value==='deActivateAccount')||
     (value==='deleteProduct')||(value==='confirmContactForm')){
      this.modalFunctionIcon = 'assets/icons/confirmation-icon.svg';
      this.LogoutButtonValue = 'Yes';
    } else if (this.contentToPrint?.value === 'decline') {
      this.modalFunctionIcon = 'assets/icons/confirmation-icon.svg';
      this.LogoutButtonValue = 'Continue';
    }  else if (this.contentToPrint?.value === 'changeFilter') {
      this.modalFunctionIcon = 'assets/icons/confirmation-icon.svg';
      this.LogoutButtonValue = 'Yes';
      this.showWarningIcon = true;
    } 

    if (this.successData || this.errorData) {
      this.firstModal = false;
    }
    if (this.errorsData) {
      this.firstModal = false;
    }
    console.log(this.contentToPrint);
  }

  logoutOrSwitch(event: any) {
    event.stopPropagation();
    this.LogoutButtonValue = 'Loading...';
  
    switch (this.contentToPrint.value) {
      case 'logout':
        this.handleLogout();
        break;
      case 'switchAccount':
        this.handleSwitchAccount();
        break;
      case 'decline':
        this.handleDecline();
        break;
      case 'deActivateAccount':
        this.handleDeactivateAccount();
        break;
      case 'changeFilter':
        this.handleChangeFilter();
        break;
      case 'deleteProduct':
        this.handleDeleteProduct();
        break;
      case 'confirmContactForm':
        this.handleConfirmContactForm();
        break;
      default:
        break;
    }
  }
  
  private handleLogout() {
    this.authService.logout().subscribe({
      next: (res) => {
        this.LogoutButtonValue = 'Logout';
        if (res.msg === 'Logout successfully!') {
          const direction = navigator.language === 'ar' ? 'rtl' : 'ltr';
          localStorage.setItem('languageDirection', direction);
          localStorage.removeItem('userLanguageLocale');
          this.store?.dispatch(clearReducer());
          this.migrattionPopUp.stopPopupCheck();
          localStorage.removeItem('lastPopuptime');
          this.router.navigate(['login']);
        }
      },
      error: (err) => {},
    });
    this.logOutEvent();
  }
  
  private handleSwitchAccount() {
    this.confirmToSwitchAccount.emit(true);
  }
  
  private handleDecline() {
    this.authService.rejectPrivatePolicy().subscribe({
      next: (res) => {
        if (res.status) {
          this.authService.logout().subscribe({
            next: (res) => {
              this.store.dispatch(clearReducer());
              this.migrattionPopUp.stopPopupCheck();
              localStorage.removeItem('lastPopuptime');
              this.router.navigate(['login']);
            },
            error: (err) => {},
          });
        }
      },
      error: (err) => {},
    });
    this.continueClickEvent();
  }
  
  private handleDeactivateAccount() {
    this.confirmToDeactivate.emit(true);
  }
  
  private handleChangeFilter() {
    const obj = { showAccordian: 'delivery' };
    this.createOrderService.setData(obj);
  
    let objToEmit;
    if (this.contentToPrint.modeOfdelivery === 'DDP') {
      objToEmit = { MOD: 'DDP', event: true, isScheduleOrder: this.cartData.showScheduleOrder };
    } else if (this.contentToPrint.modeOfdelivery === 'ROT') {
      objToEmit = { MOD: 'ROT', event: true };
    } else if(this.contentToPrint.modeOfdelivery === 'Agg'){
      objToEmit = { MOD: 'Agg', event: true };
    } else {
      objToEmit = true;
    }
    this.confirmToSwitchAccount.emit(objToEmit);
  }
  
  private handleDeleteProduct() {
    this.confirmToSwitchAccount.emit(true);
  }

  private handleConfirmContactForm() {
    this.confirmToExitForm.emit(true);
  }
  

  cancel() {
    this.cancelModal.emit(null);
    this.cancelEvent();
  }

  refreshPage() {
    if (this.successData) {
      this.confirmationData.emit(null);
    } else if (this.errorData) {
      this.cancelModal.emit(null);
    } else if (this.errorsData) {
      this.cancelModal.emit(null);
    }
  }
  // <---------------- Google-Analytics Starts -------------->
  cancelEvent() {
    let action = 'Clickcancel';
    let category = 'Users Activity';
    let label = 'click onCancel';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  continueClickEvent() {
    let action = 'ContinueClicked';
    let category = 'Setting Activity';
    let label = 'Click ContinueButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  cancelSettingEvent() {
    let action = 'Clickcancel';
    let category = 'Setting Activity';
    let label = 'click onCancel';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  logOutEvent() {
    let action = 'ClicklogOut';
    let category = 'Setting Activity';
    let label = 'click LogOutButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }

  // <---------------- Google-Analytics Ends -------------->
}
